var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column" }, [
    typeof _vm.filter.label === "object" || typeof _vm.filter.label === "array"
      ? _c("h4", { domProps: { innerHTML: _vm._s(_vm.filter.label[0]) } })
      : _c("h4", { domProps: { innerHTML: _vm._s(_vm.filter.label) } }),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "flex-column",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.applyFilter(false)
          }
        }
      },
      [
        _c(_vm.filter.component, {
          tag: "component",
          staticClass: "fs-3 filter-subcontainer ovx-hidden",
          attrs: { filter: _vm.filter },
          on: { "filter:update": _vm.updateData }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "acenter mt-3" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("listing.filters.ListingFilter.apply_filter"),
                submit: "",
                disabled: _vm.cannotSubmit
              }
            }),
            _vm._v(" "),
            !_vm.filter.active
              ? _c("CompassButton", {
                  staticClass: "mt-3",
                  attrs: {
                    label: _vm.$t.__(
                      "listing.filters.ListingFilter.add_another_filter"
                    ),
                    type: "secondary",
                    size: "small",
                    leftIcon: "plus"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.applyFilter(true)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }